import { encryptStorage } from 'src/Util'
import { usersAPI } from '../api'
import { error } from 'jquery'

export const USERMANAGEMENT_LIST_SUCCESS = 'USERMANAGEMENT_LIST_SUCCESS'
export const USERMANAGEMENT_LIST_FAILURE = 'USERMANAGEMENT_LIST_FAILURE'

export const REMAINING_LICENSES_SUCCESS = 'REMAINING_LICENSES_SUCCESS'
export const REMAINING_LICENSES_FAILURE = 'REMAINING_LICENSES_FAILURE'

export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS'
export const ADD_USER_FAILURE = 'ADD_USER_FAILURE'

export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE'

export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS'
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE'

export const GET_ROLE_LIST_SUCCESS = 'GET_ROLE_LIST_SUCCESS'
export const GET_ROLE_LIST_FAILURE = 'GET_ROLE_LIST_FAILURE'

export const GET_COMPANY_LIST_SUCCESS = 'GET_COMPANY_LIST_SUCCESS'
export const GET_COMPANY_LIST_FAILURE = 'GET_COMPANY_LIST_FAILURE'

export const GET_TOOLTIP_SUCCESS = 'GET_TOOLTIP_SUCCESS'
export const GET_TOOLTIP_FAILURE = 'GET_TOOLTIP_FAILURE'

export const ACTIVE_DEACTIVE_SUCCESS = 'ACTIVE_DEACTIVE_SUCCESS'
export const ACTIVE_DEACTIVE_FAILURE = 'ACTIVE_DEACTIVE_FAILURE'

export const RESET_TOAST_MESSAGE = 'RESET_TOAST_MESSAGE'
export const SEARCH_USER = 'SEARCH_USER'
export const SEARCH_USER_FAILURE = 'SEARCH_USER_FAILURE'

export const getUserManagementSuccess = (userManagementList) => ({
  type: USERMANAGEMENT_LIST_SUCCESS,
  payload: userManagementList,
})
export const getUserManagementFailure = (errorMessage) => ({
  type: USERMANAGEMENT_LIST_FAILURE,
  error: errorMessage,
})

export const remainingLicensesListSuccess = (userManagementList) => ({
  type: REMAINING_LICENSES_SUCCESS,
  payload: userManagementList,
})
export const remainingLicensesListFailure = (errorMessage) => ({
  type: REMAINING_LICENSES_FAILURE,
  error: errorMessage,
})

export const addUserSuccess = (res) => ({
  type: ADD_USER_SUCCESS,
  payload: res,
})
export const addUserFailure = (errorMessage) => ({
  type: ADD_USER_FAILURE,
  error: errorMessage,
})

export const activeDeactiveSuccess = (res) => ({
  type: ACTIVE_DEACTIVE_SUCCESS,
  payload: res,
})
export const activeDeactiveFailure = (errorMessage) => ({
  type: ACTIVE_DEACTIVE_FAILURE,
  error: errorMessage,
})

export const updateUserSuccess = (res) => ({
  type: UPDATE_USER_SUCCESS,
  payload: res,
})
export const updateUserFailure = (errorMessage) => ({
  type: UPDATE_USER_FAILURE,
  error: errorMessage,
})

export const deleteUserSuccess = (res) => ({
  type: DELETE_USER_SUCCESS,
  payload: res,
})
export const deleteUserFailure = (errorMessage) => ({
  type: DELETE_USER_FAILURE,
  error: errorMessage,
})

export const getRoleListSuccess = (res) => ({
  type: GET_ROLE_LIST_SUCCESS,
  payload: res,
})
export const getRoleListFailure = (errorMessage) => ({
  type: GET_ROLE_LIST_FAILURE,
  error: errorMessage,
})

export const getCompanyListSuccess = (res) => ({
  type: GET_COMPANY_LIST_SUCCESS,
  payload: res,
})
export const getCompanyListFailure = (errorMessage) => ({
  type: GET_COMPANY_LIST_FAILURE,
  error: errorMessage,
})

export const getPermissionToolTipSuccess = (res) => ({
  type: GET_TOOLTIP_SUCCESS,
  payload: res,
})
export const getPermissionToolTipFailure = (errorMessage) => ({
  type: GET_TOOLTIP_FAILURE,
  error: errorMessage,
})

export const getUserManagementList = (dat) => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  const data = {
    company_id: dat.companyId,
    current_user_id: userDetail.user_id,
    offset: dat.offset,
    limit: dat.page,
  }
  usersAPI
    .post('user/All/bycompanyid/', data)
    .then((res) => {
      dispatch(getUserManagementSuccess(res))
    })
    .catch((error) => {
      dispatch(getUserManagementFailure(error))
    })
}

export const searchUserByEmail = (reqObj) => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  const data = {
    company_id: reqObj.companyId,
    current_user_id: userDetail.user_id,
    offset: reqObj.offset,
    // offset:0,
    // limit: reqObj.page,
    limit:10,
    email_id:reqObj.email_id,
  }
  usersAPI.post('user/All/bycompanyid/', data)
  .then((res) => {
    dispatch({
      type: SEARCH_USER,
      payload: res
    })
  }).catch((error)=> {
    dispatch({
      type: SEARCH_USER_FAILURE,
      payload: error
    })
  })
}

export const getRemainingLicenseList = (dat) => (dispatch) => {
  usersAPI
    .get(`user/remaining_licenses/${dat.value}`)
    .then((res) => {
      dispatch(remainingLicensesListSuccess(res))
    })
    .catch((error) => {
      dispatch(remainingLicensesListFailure(error))
    })
}

export const addUser = (data) => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  usersAPI
    .post(`user/add?loggedUserId=${userDetail.user_id}`, data)
    .then((res) => {
      dispatch(addUserSuccess(res))
    })
    .catch((error) => {
      dispatch(addUserFailure(error))
    })
}

export const activeDeactive = (status, userId) => (dispatch) => {
  const toggleStatus = status ? false : true
  const userDetail = encryptStorage.getItem('session-user')
  usersAPI
    .put(`user/activate/${toggleStatus}/${userId}?loggedUserId=${userDetail.user_id}`)
    .then((res) => {
      dispatch(activeDeactiveSuccess(res))
    })
    .catch((error) => {
      dispatch(activeDeactiveFailure(error))
    })
}

export const updateUser = (userId, data) => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  usersAPI
    .put(`user/update/${userId}?loggedUserId=${userDetail.user_id}`, data)
    .then((res) => {
      dispatch(updateUserSuccess(res.data))
    })
    .catch((error) => {
      dispatch(updateUserFailure(error))
    })
}

export const deleteUser = (userId) => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  usersAPI
    .delete(`user/delete/${userId}?loggedUserId=${userDetail.user_id}`)
    .then((res) => {
      dispatch(deleteUserSuccess(res))
    })
    .catch((error) => {
      dispatch(deleteUserFailure(error))
    })
}

export const getRoleList = () => (dispatch) => {
  usersAPI
    .get(`user/role/All`)
    .then((res) => {
      dispatch(getRoleListSuccess(res))
    })
    .catch((error) => {
      dispatch(getRoleListFailure(error))
    })
}

export const getCompanyList = () => (dispatch) => {
  usersAPI
    .get(`user/company/all`)
    .then((res) => {
      dispatch(getCompanyListSuccess(res))
    })
    .catch((error) => {
      dispatch(getCompanyListFailure(error))
    })
}

export const getpermissionToolTip = () => (dispatch) => {
  usersAPI
    .get(`user/role_rights/`)
    .then((res) => {
      dispatch(getPermissionToolTipSuccess(res))
    })
    .catch((error) => {
      dispatch(getPermissionToolTipFailure(error))
    })
}

export const resetToastMessage = () => (dispatch) => {
  dispatch({
    type: RESET_TOAST_MESSAGE,
  })
}
